interface LogoProps {
  size?: number
  title?: string
}

export function Logo({ size = 34, title }: LogoProps) {
  return (
    <svg
      className="logo"
      width={size}
      height={size}
      viewBox="0 0 240 240"
      role={title === undefined ? 'presentation' : 'img'}
      aria-hidden={title === undefined ? true : undefined}
      aria-label={title}
      focusable="false"
    >
      <path d="M0 0 H120 A120 120 0 0 1 238.32 140 H0 Z" className="logo__upper" />
      <path d="M0 156 H234.47 A120 120 0 0 1 120 240 H0 Z" className="logo__lower" />
    </svg>
  )
}
